import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./FormGroup.module.css";

const FormGroup = ({ label, icon, children, required = false, className }) => {
	return (
		<div className={`${styles.formGroup} ${className || ""}`}>
			{label && (
				<label className={styles.label}>
					{icon && <FontAwesomeIcon icon={icon} className={styles.icon} />}
					{label}
					{required && <span className={styles.required}>*</span>}
				</label>
			)}
			{children}
		</div>
	);
};

export default FormGroup;
